<template>
    <section class="section">
        <div class="container">
            <div class="columns is-centered" style="margin: 0;">
                <div class="box column is-one-third">
                    <div class="content">
                        <h2>Login</h2>
                    </div>
                    <form v-on:submit.prevent>
                        <b-field label="Email">
                            <b-input type="email" placeholder="Your email address" v-model.trim="loginForm.email"></b-input>
                        </b-field>
                        <b-field label="Password">
                            <b-input type="password" placeholder="Your password" @keyup.native.enter="login" v-model.trim="loginForm.password"></b-input>
                        </b-field>
                        <b-field class="login-button">
                            <b-button type="submit" class="button is-primary" :loading="isLoading" @click="login">Let's go!</b-button>
                        </b-field>
                        <b-field class="reset-link">
                            <router-link to="/reset">
                                <p>Forgot your password?</p>
                            </router-link>
                        </b-field>
                        <hr>
                        <b-field class="register-link">
                            <router-link to="/register">
                                <p>Don't have an account? Register here.</p>
                            </router-link>
                        </b-field>
                    </form>
                    <!-- Below view used for a warning sign if user is logged out due to inactivity -->
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: function() {
        return {
            loginForm: {
                email: "",
                password: ""
            }
        }
    },
    computed: {
        isLoading() {
            return this.$store.state.loading;
        }
    },
    components: {
    },
    methods: {
        login: function() {
            this.$store.dispatch("login", {
                email: this.loginForm.email,
                password: this.loginForm.password
            });
            this.loginForm.email = "",
            this.loginForm.password = ""
        } 
    }
}
</script>

<style scoped>
.box {
    margin-top: 10vh;
    margin-left: 2%;
    margin-right: 2%;
    margin-bottom: 10vh;
    padding: 40px;
}
.login-button {
    margin-top: 5%;
}
</style>